module.exports = __webpack_public_path__ + "static/media/icon-switch.6bcb3829.svg";